import {
  Component,
  HostListener
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

import Swal from 'sweetalert2';

import {
  CheckoutService,
  ReservaCalendario
} from '../../service/checkout.service';

import {
  QuartoService
} from '../../service/quarto.service';
import {
  RegrasMinimoNoitesService,
  RegraMinimoNoites
} from '../../service/RegraMinimoNoites.service';


import { forkJoin } from 'rxjs';
interface Acomodacao {

  id: number;
  nome: string;
  descricao: string;
  imagem: string;
  rota: string;
}

interface DiaCalendario {
  numero: number;
  data: Date;
  mesAtual: boolean;
  hoje: boolean;
  selecionado: boolean;
  intervalo: boolean;
  desabilitado: boolean;
}

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule,
    RouterLink],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {

  feedbacks: string[] = [
    '/feedback-1.png',
    '/feedback-2.png',
    '/feedback-3.PNG',
    '/feedback-4.PNG',
    '/feedback-5.PNG',
    '/feedback-6.PNG',
    '/feedback-7.PNG',
    '/feedback-8.PNG',
    '/feedback-9.PNG',
    '/feedback-10.PNG'
  ];

  feedbackAtual: number = 0;

  regrasMinimoNoites: RegraMinimoNoites[] = [];

  carregandoCalendario = false;

  erroCalendario = false;

  get minimoNoitesSelecionado(): number {
    if (!this.dataEntrada) {
      return 1;
    }

    const data = this.formatarDataBackend(this.dataEntrada);

    const regra = this.regrasMinimoNoites.find(
      r => r.data === data && r.ativo
    );

    return regra?.minimoNoites ?? 1;
  }

  get checkoutMinimo(): Date | null {
    if (!this.dataEntrada) {
      return null;
    }

    const data = new Date(
      this.dataEntrada.getFullYear(),
      this.dataEntrada.getMonth(),
      this.dataEntrada.getDate()
    );

    data.setDate(
      data.getDate() + this.minimoNoitesSelecionado
    );

    return data;
  }


  feedbackProximo(): void {

    if (this.feedbackAtual < this.feedbacks.length - 1) {
      this.feedbackAtual++;
    } else {
      this.feedbackAtual = 0;
    }

  }

  @HostListener('document:click', ['$event'])
  fecharMenusAoClicarFora(event: MouseEvent): void {

    const elemento = event.target as HTMLElement;

    const clicouDentroDoMenu =
      elemento.closest('.dropdown-reserva') ||
      elemento.closest('.calendario-dropdown') ||
      elemento.closest('.reserva-select') ||
      elemento.closest('.reserva-date');

    if (clicouDentroDoMenu) {
      return;
    }

    this.mostrarAcomodacoes = false;
    this.mostrarHospedes = false;
    this.mostrarCalendario = false;
  }


  feedbackAnterior(): void {

    if (this.feedbackAtual > 0) {
      this.feedbackAtual--;
    } else {
      this.feedbackAtual = this.feedbacks.length - 1;
    }

  }


  irParaFeedback(index: number): void {
    this.feedbackAtual = index;
  }

  acomodacoes: Acomodacao[] = [

    {
      id: 1,
      nome: 'Cabana Ypê',
      descricao: 'Cabana confortável em meio à natureza',
      imagem: '/cabana-ype.PNG',
      rota: '/cabana-ype'
    },

    {
      id: 2,
      nome: 'Chalé Santorini',
      descricao: 'Um pedaço da Grécia em meio ao Cerrado de Goiás',
      imagem: '/chale-santorini.jpeg',
      rota: '/chale-santorini'
    }

  ];

  acomodacaoSelecionada: string = '';

  mostrarAcomodacoes: boolean = false;

  reservasOcupadas: ReservaCalendario[] = [];


  toggleAcomodacoes(): void {

    this.mostrarAcomodacoes = !this.mostrarAcomodacoes;

    this.mostrarHospedes = false;

  }


  selecionarAcomodacao(
    acomodacao: Acomodacao
  ): void {

    this.acomodacaoSelecionada = acomodacao.nome;

    this.mostrarAcomodacoes = false;

    this.reservasOcupadas = [];
    this.regrasMinimoNoites = [];

    this.dataEntrada = null;
    this.dataSaida = null;

    this.modoCalendario = 'entrada';

    this.carregandoCalendario = true;
    this.erroCalendario = false;

    this.gerarCalendario();

    forkJoin({
      reservas: this.checkoutService.buscarDatasOcupadas(
        acomodacao.id
      ),
      regras: this.regrasMinimoNoitesService.listarPublicas(
        acomodacao.id
      )
    }).subscribe({

      next: ({ reservas, regras }) => {

        this.reservasOcupadas = reservas;
        this.regrasMinimoNoites = regras;

        this.carregandoCalendario = false;
        this.erroCalendario = false;

        this.gerarCalendario();
      },

      error: () => {

        this.carregandoCalendario = false;
        this.erroCalendario = true;

        this.reservasOcupadas = [];
        this.regrasMinimoNoites = [];

        this.gerarCalendario();

        Swal.fire({
          icon: 'error',
          title: 'Erro ao carregar calendário',
          text: 'Não foi possível consultar as datas e as regras de hospedagem. Tente selecionar a acomodação novamente.',
          confirmButtonColor: '#696A49'
        });
      }
    });
  }

  private dataEstaOcupada(
    data: Date
  ): boolean {

    const dataString =
      this.formatarDataBackend(data);

    return this.reservasOcupadas.some(
      reserva => {

        return (
          dataString >= reserva.checkIn &&
          dataString < reserva.checkOut
        );

      }
    );

  }

  mostrarHospedes: boolean = false;

  adultos: number = 0;
  criancas: number = 0;
  animais: number = 0;


  get totalHospedes(): number {

    return this.adultos + this.criancas;

  }


  toggleHospedes(): void {

    this.mostrarHospedes = !this.mostrarHospedes;

    this.mostrarAcomodacoes = false;

  }


  alterarHospedes(
    tipo: 'adultos' | 'criancas' | 'animais',
    valor: number
  ): void {

    if (tipo === 'adultos') {

      this.adultos = Math.max(
        1,
        this.adultos + valor
      );

    }

    if (tipo === 'criancas') {

      this.criancas = Math.max(
        0,
        this.criancas + valor
      );

    }

    if (tipo === 'animais') {
      this.animais = Math.max(
        0,
        Math.min(2, this.animais + valor)
      );
    }

  }

  mostrarCalendario: boolean = false;

  modoCalendario: 'entrada' | 'saida' = 'entrada';

  dataEntrada: Date | null = null;

  dataSaida: Date | null = null;


  dataCalendario: Date = new Date();

  mesAtual: number = this.dataCalendario.getMonth();

  anoAtual: number = this.dataCalendario.getFullYear();


  nomesMeses: string[] = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
  ];


  diasCalendario: DiaCalendario[] = [];


  constructor(
    private checkoutService: CheckoutService,
    private router: Router,
    private quartoService: QuartoService,
    private regrasMinimoNoitesService: RegrasMinimoNoitesService
  ) {
    this.gerarCalendario();
  }


  abrirCalendario(
    modo: 'entrada' | 'saida'
  ): void {

    if (!this.acomodacaoSelecionada) {
      Swal.fire({
        icon: 'warning',
        title: 'Selecione uma acomodação',
        text: 'Escolha primeiro a acomodação para consultar as datas disponíveis.',
        confirmButtonColor: '#696A49'
      });
      return;
    }

    this.modoCalendario = modo;
    this.mostrarCalendario = true;
    this.mostrarAcomodacoes = false;
    this.mostrarHospedes = false;

    this.gerarCalendario();
  }


  gerarCalendario(): void {

    const primeiroDia = new Date(
      this.anoAtual,
      this.mesAtual,
      1
    );

    const ultimoDia = new Date(
      this.anoAtual,
      this.mesAtual + 1,
      0
    );

    const dias: DiaCalendario[] = [];

    // Domingo = 0
    // Segunda = 1
    // Terça = 2
    // ...
    // Sábado = 6
    const primeiroDiaSemana =
      primeiroDia.getDay();

    // Cria espaços vazios antes do dia 1
    // para respeitar o dia da semana.
    for (
      let i = 0;
      i < primeiroDiaSemana;
      i++
    ) {

      dias.push({
        numero: 0,
        data: new Date(0),
        mesAtual: false,
        hoje: false,
        selecionado: false,
        intervalo: false,
        desabilitado: true
      });

    }

    // Adiciona somente os dias do mês atual
    for (
      let i = 1;
      i <= ultimoDia.getDate();
      i++
    ) {

      const data = new Date(
        this.anoAtual,
        this.mesAtual,
        i
      );

      dias.push(
        this.criarDia(
          data,
          true
        )
      );

    }

    this.diasCalendario = dias;

  }


  criarDia(
    data: Date,
    mesAtual: boolean
  ): DiaCalendario {

    const hoje = new Date();

    const dataSemHora = new Date(
      data.getFullYear(),
      data.getMonth(),
      data.getDate()
    );

    const hojeSemHora = new Date(
      hoje.getFullYear(),
      hoje.getMonth(),
      hoje.getDate()
    );

    const selecionado =
      this.mesmaData(dataSemHora, this.dataEntrada) ||
      this.mesmaData(dataSemHora, this.dataSaida);

    const intervalo =
      this.dataEntrada !== null &&
      this.dataSaida !== null &&
      dataSemHora > this.dataEntrada &&
      dataSemHora < this.dataSaida;

    const ocupado = this.dataEstaOcupada(dataSemHora);

    let desabilitado =
      !mesAtual ||
      dataSemHora <= hojeSemHora ||
      this.carregandoCalendario ||
      this.erroCalendario ||
      !this.acomodacaoSelecionada;

    if (this.modoCalendario === 'entrada') {

      if (ocupado) {
        desabilitado = true;
      }

    } else if (this.modoCalendario === 'saida') {

      if (!this.dataEntrada) {

        desabilitado = true;

      } else {

        const entrada = new Date(
          this.dataEntrada.getFullYear(),
          this.dataEntrada.getMonth(),
          this.dataEntrada.getDate()
        );

        const checkoutMinimo = this.checkoutMinimo;

        // Bloqueia datas anteriores ao mínimo obrigatório.
        if (
          dataSemHora <= entrada ||
          (checkoutMinimo && dataSemHora < checkoutMinimo)
        ) {

          desabilitado = true;

        } else {

          const entradaString =
            this.formatarDataBackend(entrada);

          const saidaString =
            this.formatarDataBackend(dataSemHora);

          // Mantém a verificação de conflitos existente.
          const existeConflito =
            this.reservasOcupadas.some(
              reserva =>
                entradaString < reserva.checkOut &&
                saidaString > reserva.checkIn
            );

          if (existeConflito) {
            desabilitado = true;
          }
        }
      }
    }

    return {
      numero: data.getDate(),
      data,
      mesAtual,
      hoje: this.mesmaData(dataSemHora, hojeSemHora),
      selecionado,
      intervalo,
      desabilitado
    };
  }



  selecionarData(
    dia: DiaCalendario
  ): void {

    if (
      dia.desabilitado ||
      this.carregandoCalendario ||
      this.erroCalendario
    ) {
      return;
    }

    if (this.modoCalendario === 'entrada') {

      this.dataEntrada = new Date(dia.data);
      this.dataSaida = null;

      this.modoCalendario = 'saida';

      this.gerarCalendario();

      // Mantém o calendário aberto para escolher a saída.
      return;
    }

    if (this.modoCalendario === 'saida') {

      this.dataSaida = new Date(dia.data);

      this.mostrarCalendario = false;

      this.gerarCalendario();
    }
  }


  mesAnterior(): void {

    this.mesAtual--;

    if (this.mesAtual < 0) {

      this.mesAtual = 11;

      this.anoAtual--;

    }

    this.gerarCalendario();

  }


  mesProximo(): void {

    this.mesAtual++;

    if (this.mesAtual > 11) {

      this.mesAtual = 0;

      this.anoAtual++;

    }

    this.gerarCalendario();

  }


  mesmaData(
    data1: Date | null,
    data2: Date | null
  ): boolean {

    if (!data1 || !data2) {
      return false;
    }

    return (
      data1.getFullYear() === data2.getFullYear() &&
      data1.getMonth() === data2.getMonth() &&
      data1.getDate() === data2.getDate()
    );

  }


  formatarData(
    data: Date | null
  ): string {

    if (!data) {
      return '';
    }

    return new Intl.DateTimeFormat(
      'pt-BR',
      {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }
    ).format(data);

  }

  buscarDisponibilidade(): void {

    if (!this.acomodacaoSelecionada) {

      Swal.fire({
        icon: 'warning',
        title: 'Acomodação não selecionada',
        text: 'Selecione uma acomodação para continuar.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#596238'
      });

      return;
    }

    if (!this.dataEntrada || !this.dataSaida) {

      Swal.fire({
        icon: 'warning',
        title: 'Datas não selecionadas',
        text: 'Selecione o check-in e o check-out.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#596238'
      });

      return;
    }

    const acomodacao = this.acomodacoes.find(
      a => a.nome === this.acomodacaoSelecionada
    );

    if (!acomodacao) {

      Swal.fire({
        icon: 'error',
        title: 'Acomodação inválida',
        text: 'Não foi possível identificar a acomodação selecionada.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#596238'
      });

      return;
    }

    const quantidadeHospedes =
      this.adultos + this.criancas;

    if (quantidadeHospedes < 1) {

      Swal.fire({
        icon: 'warning',
        title: 'Hóspede obrigatório',
        text: 'Informe pelo menos 1 hóspede.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#596238'
      });

      return;
    }

    this.quartoService
      .buscarPorId(acomodacao.id)
      .subscribe({

        next: (quarto) => {

          if (
            quantidadeHospedes > quarto.capacidade
          ) {

            Swal.fire({
              icon: 'warning',
              title: 'Capacidade excedida',
              text:
                `Esta acomodação permite no máximo ${quarto.capacidade} ${
                  quarto.capacidade === 1
                    ? 'hóspede'
                    : 'hóspedes'
                }. Informe uma quantidade entre 1 e ${quarto.capacidade}.`,
              confirmButtonText: 'OK',
              confirmButtonColor: '#596238'
            });

            return;
          }

          const checkIn =
            this.formatarDataBackend(
              this.dataEntrada!
            );

          const checkOut =
            this.formatarDataBackend(
              this.dataSaida!
            );

          this.checkoutService
            .verificarDisponibilidade(
              acomodacao.id,
              checkIn,
              checkOut
            )
            .subscribe({

              next: (resposta) => {

                if (!resposta.disponivel) {

                  Swal.fire({
                    icon: 'warning',
                    title: 'Acomodação indisponível',
                    text:
                      'Essa acomodação não está disponível para as datas selecionadas.',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#596238'
                  });

                  return;
                }

                this.checkoutService.atualizar({

                  quartoId:
                  acomodacao.id,

                  quartoNome:
                  acomodacao.nome,

                  quartoImagem:
                  acomodacao.imagem,

                  checkIn,

                  checkOut,

                  adultos:
                  this.adultos,

                  criancas:
                  this.criancas,

                  animais:
                  this.animais,

                  quantidadeHospedes

                });

                this.router.navigate([
                  acomodacao.rota
                ]);

              },

              error: () => {

                Swal.fire({
                  icon: 'error',
                  title: 'Erro ao consultar disponibilidade',
                  text:
                    'Não foi possível verificar a disponibilidade da acomodação.',
                  confirmButtonText: 'OK',
                  confirmButtonColor: '#596238'
                });

              }

            });

        },

        error: () => {

          Swal.fire({
            icon: 'error',
            title: 'Erro ao carregar acomodação',
            text:
              'Não foi possível verificar a capacidade da acomodação.',
            confirmButtonText: 'OK',
            confirmButtonColor: '#596238'
          });

        }

      });

  }

  private formatarDataBackend(
    data: Date
  ): string {

    const ano =
      data.getFullYear();

    const mes =
      String(data.getMonth() + 1)
        .padStart(2, '0');

    const dia =
      String(data.getDate())
        .padStart(2, '0');

    return `${ano}-${mes}-${dia}`;
  }

}
